import {configureApi, configureWhitelabelToken} from "@/services/common-api";
import {patchWhiteLabelStore} from "@/store/whitelabel.store";

export interface Config {
    baseUrl: string;
    whiteLabelToken: string;
    stripePublicKey: string;
    googleMapsApiKey?: string;
}

export const initWhiteLabel = (options: Config) => {
    configureApi(options.baseUrl);
    configureWhitelabelToken(options.whiteLabelToken);
    patchWhiteLabelStore({
        stripePublicKey: options.stripePublicKey,
        googleMapsApiKey: options.googleMapsApiKey
    })

}